<template>
    <span :style="'color:'+stateColor()">{{AfterSaleStateEnums[state]}}</span>
</template>

<script>
export default {
    name: "AfterSaleStateRender",
    props: {
        state: Number
    },
    data()
    {
        let AfterSaleState = top.Constant.OppiotSystem.AfterSaleState;
        return {
            AfterSaleState: AfterSaleState,
            AfterSaleStateEnums: AfterSaleState.Enums,
            colors: {
                [AfterSaleState.Submitted]: '#0099FF',
                [AfterSaleState.Completed]: '#009900',
                [AfterSaleState.Canceled]: 'gray',
            }
        }
    },
    methods: {
        stateColor()
        {
            return this.colors[this.state]? this.colors[this.state]: 'gray';
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/erp/components/render/AfterSaleStateRender.vue